import { createSlice } from "@reduxjs/toolkit";
import { getPharmacyPopularProducts } from "../../reducer/pharmacyPopularProducts/pharmacyPopularProductsReducer";

import i18n from "../../i18n";
const initialState = { data: null, isLoading: false, error: null };

const pharmacyPopularProductsSlice = createSlice({
  name: "pharmacyPopularProducts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPharmacyPopularProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPharmacyPopularProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || null;
      })
      .addCase(getPharmacyPopularProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("pharmacy.toast.failedToLoadPopularProducts");
      });
  },
});

export default pharmacyPopularProductsSlice.reducer;
